exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-staff th[data-v-2b455ef8]{border-top:0;padding:2px 5px}.table-staff tr td[data-v-2b455ef8]{border-top:1px solid #b7b7b7;padding:2px 5px}.table-staff .area[data-v-2b455ef8]{text-align:center;font-size:1.8rem}.table-staff .staff[data-v-2b455ef8]{background:#fff}.table-staff .staff[data-v-2b455ef8]:hover{background:rgba(195,255,172,.75)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2b455ef8&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/ActiveEmployees.vue
// module id = 221
// module chunks = 0